// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="overview">Overview</h2>
      <p>Our goal is to make it easier to keep up with the ever-changing landscape of VA forms. This API indexes data sourced from <a href="https://www.va.gov/vaforms/search_action.asp">VA.gov</a>, creating unique hashes for each version of a form and allowing quick lookup.</p>
    </div>
  );
};

export default MarkdownComponent;
